import { render, staticRenderFns } from "./MatchedGroupCard.vue?vue&type=template&id=6896a5c5&scoped=true"
import script from "./MatchedGroupCard.vue?vue&type=script&lang=js"
export * from "./MatchedGroupCard.vue?vue&type=script&lang=js"
import style0 from "./MatchedGroupCard.vue?vue&type=style&index=0&id=6896a5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896a5c5",
  null
  
)

export default component.exports